import React from "react";
import hero from "../img/hero.png";
import Model from "@tripian/model";
import { SvgIcons } from "@tripian/react";

type Props = {
  onClickGetStarted: () => void;
  t: (value: Model.TranslationKey) => string;
};

const YourPersonalTripPlanner: React.FC<Props> = ({ onClickGetStarted, t }) => {
  return (
    <div className="relative w-full h-[1021px] md:h-[900px] -translate-y-[5%] md:translate-y-0">
      <img
        src={hero}
        alt="Coastal city view"
        className="absolute inset-0 w-full h-full object-cover filter brightness-150 contrast-75"
      />
      <div className="absolute inset-0 bg-black bg-opacity-30" />
      <div className="absolute inset-0 bg-[#1434CB] bg-opacity-5" />
      <div className="relative z-10 flex flex-col justify-center h-full px-8 md:px-16 text-start max-w-3xl">
        <p
          className="font-medium max-[390px]:text-base/[5rem] text-lg/[5rem] md:text-xl/[5rem] bg-primary-color bg-clip-text text-transparent"
          style={{
            textShadow: "0 1px 1px rgba(0,0,0,0.15)",
          }}
        >
          {t("landing.yourPersonalTripPlanner")}
        </p>
        <h1 className="text-4xl md:text-[4.375rem]/[5.3125rem] font-montserrat font-bold text-zinc-50 mb-10 md:mb-6 leading-snug tracking-wide">
          {t("landing.title")}
        </h1>
        <p className="text-zinc-50 text-2xl/[2.5rem] font-normal mb-16 md:mb-8">
          {t("landing.description")}
        </p>
        <button
          className="flex items-center space-x-3 rtl:space-x-reverse bg-primary-color text-white font-semibold rounded-full transition duration-200 size-fit px-10 py-5 w-fit"
          onClick={onClickGetStarted}
        >
          <span className="text-base md:text-xl">
            {t("landing.getStartedNow")}
          </span>
          <SvgIcons.ArrowRight2 size="1.5rem" />
        </button>
      </div>
    </div>
  );
};

export default YourPersonalTripPlanner;
